<template>
	<div>
		<edit-location
			v-if="editLocationOpen"
			@SET_EDIT_LOCATION="editLocationOpen = false"
			:retailerData="retailerData"
			:themeInputColor="themeInputColor"
		/>
		<div v-else>
			<div class="justify-end" v-if="isJeet11Retailer">
				<v-btn
					@click="editLocationOpen = true"
					:color="themeInputColor"
					:disabled="
						jeet11PartnerDetails.shopStatus !== null &&
							jeet11PartnerDetails.shopStatus !== 'rejected'
					"
					class="white--text"
				>
					<v-icon dark>edit</v-icon>
					<span class="px-2">
						Add Location
					</span>
				</v-btn>
			</div>
			<v-form
				lazy-validation
				@submit.prevent
				:style="isEditMode ? 'opacity: 1' : 'opacity: 0.5'"
			>
				<v-layout row wrap mt-2 mb-5>
					<div
						class="full-width px-3 pt-4 pb-3 border-outline mx-3 mb-5 pos-rel"
					>
						<div class="section-heading">
							<h6 class="mb-0">Personal Details</h6>
						</div>
						<v-flex xs12 sm6>
							<v-text-field
								label="Retailer Name*"
								outline
								v-model="retailerName"
								:disabled="!isEditMode"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6 v-if="!isJeet11TSM && !isJeet11RBM">
							<v-text-field
								label="TSM Number*"
								outline
								v-model="retailerDetails.tsmNumber"
								:rules="[validatePhone]"
								:disabled="!isEditMode"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6 v-if="isJeet11TSM">
							<v-text-field
								label="RBM Number*"
								outline
								v-model="retailerDetails.rbmNumber"
								:rules="[validatePhone]"
								:disabled="!isEditMode"
							></v-text-field>
						</v-flex>
						<v-textarea
							outline
							v-model="retailerDetails.address"
							name="Add Address"
							label="Address*"
							:disabled="addressAlreadyExists"
						></v-textarea>
						<v-flex xs12 sm6>
							<v-select
								:items="states"
								v-model="selectedState"
								label="State*"
								outline
								name="Select State"
								:loading="fetchStatesLoading"
								:disabled="disableStateSelect"
							></v-select>
						</v-flex>
						<v-flex xs12 sm6>
							<v-select
								:items="cities"
								v-model="selectedCity"
								label="City*"
								outline
								name="Select City"
								:loading="fetchCitiesLoading"
								:disabled="disableCitySelect"
							></v-select>
						</v-flex>
					</div>
					<div
						class="full-width px-3 pt-4 pb-3 border-outline mx-3 mb-5 pos-rel"
					>
						<div class="section-heading">
							<h6 class="mb-0">Bank Details</h6>
						</div>
						<v-flex xs12 sm6>
							<v-text-field
								label="Account Number*"
								v-model="bankDetails.accountNumber"
								outline
								:disabled="isUserCreated"
								:rules="[onlyDigitsRule]"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6>
							<v-text-field
								label="Account holder's Name*"
								v-model="bankDetails.accountName"
								outline
								:disabled="isUserCreated"
							></v-text-field>
							<v-flex xs12 sm6>
								<v-text-field
									label="IFSC Code*"
									v-model="bankDetails.accountIfsc"
									outline
									:disabled="isUserCreated"
									:rules="[validIFSCRule]"
									class="uppercase"
								></v-text-field>
							</v-flex>
						</v-flex>
					</div>
					<div
						class="full-width px-3 pt-4 pb-3 border-outline mx-3 mb-5 pos-rel"
					>
						<div class="section-heading">
							<h6 class="mb-0">PAN Details</h6>
						</div>
						<v-flex xs12 sm6>
							<v-text-field
								label="PAN Number*"
								v-model="documentDetails.PAN"
								outline
								:rules="[checkValidPanRule]"
								class="uppercase"
								:disabled="isPANDetailsExist"
							></v-text-field>
						</v-flex>

						<upload-media
							text="Upload PAN Card*"
							:acceptsReg="/\.(pdf)$/i"
							accept="image/*"
							@SAVE_FILE_URL="savePANImage"
							:fileUrl="documentDetails.PANimage"
							:disabled="isPANDetailsExist"
						>
						</upload-media>
					</div>
					<div
						v-if="isJeet11Distributor"
						class="full-width px-3 pt-4 pb-3 border-outline mx-3 mb-5 pos-rel"
					>
						<div class="section-heading">
							<h6 class="mb-0">GST Details</h6>
						</div>
						<v-flex xs12 sm6>
							<v-text-field
								label="Shop Name*"
								v-model="retailerDetails.shopName"
								outline
								:disabled="shopNameExists"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6>
							<v-text-field
								label="GSTIN No*"
								v-model="documentDetails.gstNumber"
								outline
								:disabled="gstNumberExists"
							></v-text-field>
						</v-flex>
						<v-flex xs12 sm6>
							<upload-media
								text="Upload GST Certificate (only .pdf)*"
								:acceptsReg="/\.(pdf)$/i"
								accept="application/pdf"
								@SAVE_FILE_URL="saveGSTCertificate"
								:fileUrl="documentDetails.gstCertificate"
								:disabled="gstCertificateExists"
							/>
						</v-flex>
					</div>
					<div
						v-if="isJeet11Distributor"
						class="full-width px-3 pt-4 pb-3 border-outline mx-3 mb-5 pos-rel"
					>
						<div class="section-heading">
							<h6 class="mb-0">Signature Upload</h6>
							<div
								v-if="dstrSignatureStatus === STATUS.REJECTED"
								class="notif-dot"
							/>
						</div>
						<upload-media
							v-if="!(dstrSignatureStatus === STATUS.PENDING)"
							text="Upload Signature*"
							:acceptsReg="/\.(pdf)$/i"
							accept="image/*"
							@SAVE_FILE_URL="saveSignature"
							:fileUrl="documentDetails.signature"
							:disabled="
								!(dstrSignatureStatus === STATUS.REJECTED)
							"
						/>
						<div
							v-if="dstrSignatureStatus === STATUS.PENDING"
							class="text-center body-2 py-5"
						>
							SIGNATURE APPROVAL IS PENDING
						</div>
						<div
							style="color: red"
							v-if="
								dstrSignatureStatus === STATUS.REJECTED &&
									dstrSignatureRemark
							"
						>
							Your signature was rejected - Reason:
							{{ dstrSignatureRemark }}
						</div>
					</div>
				</v-layout>
			</v-form>
			<v-layout class="submit-btn elevation-3 pa-2">
				<div v-if="isEditMode" class="justify-around d-flex full-width">
					<div class="text-center">
						<v-btn outline color="error" @click="resetForm"
							>Cancel</v-btn
						>
					</div>
					<div class="text-center">
						<v-btn
							@click="updateRetailerProfile"
							color="green"
							class="white--text"
							:loading="isUpdateProfileLoading"
							>{{
								isUserCreated ? "Edit Profile" : "Save Profile"
							}}</v-btn
						>
					</div>
				</div>
				<div v-else class="full-width d-flex justify-center">
					<v-btn
						@click="isEditMode = true"
						:color="themeInputColor"
						class="white--text"
					>
						<v-icon dark>edit</v-icon>
						<span class="px-2">
							Edit Profile
						</span>
					</v-btn>
				</div>
			</v-layout>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import * as utils from "@/utils.js";
import {
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	FETCH_REGIONS,
	GET_RETAILER_PROFILE,
	SHOW_ALERT,
	UPDATE_RETAILER_PROFILE
} from "@/store/action-types";
import UploadMedia from "@/components/UploadMedia";
import {
	checkValidPAN,
	REGION_TYPE,
	validIFSC,
	_onlyDigitsRule
} from "@/utils";
import { checkPhoneNumberValidity, _validPhoneNoRule } from "../../utils";
import {
	GET_DSTR_SIGNATURE,
	UPLOAD_DSTR_SIGNATURE
} from "../../store/action-types";
import { STATUS } from "../constants";
import EditLocation from "./editLocation.vue";

const formInitialState = Object.assign(
	{},
	{
		retailerDetails: {
			shopName: "",
			address: "",
			tsmNumber: "",
			rbmNumber: ""
		},
		bankDetails: {
			accountNumber: "",
			accountIfsc: "",
			accountName: ""
		},
		documentDetails: {
			gstNumber: "",
			gstCertificate: "",
			PAN: "",
			PANimage: "",
			signature: ""
		}
	}
);

export default {
	name: "Profile",
	data() {
		return {
			themeInputColor: utils.themeInputColor,
			...formInitialState,
			states: [],
			cities: [],
			selectedState: null,
			defaultCity: null,
			selectedCity: null,
			retailerName: "",
			userType: "",
			fetchStatesLoading: false,
			fetchCitiesLoading: false,
			isUpdateProfileLoading: false,
			isUserCreated: false,
			isEditMode: false,
			isPANDetailsExist: false,
			stateAlreadySelected: false,
			cityAlreadySelected: false,
			addressAlreadyExists: false,
			gstNumberExists: false,
			shopNameExists: false,
			gstCertificateExists: false,
			validIFSCRule: v => validIFSC(v) || "IFSC is not valid",
			onlyDigitsRule: v => _onlyDigitsRule(v),
			checkValidPanRule: v =>
				checkValidPAN(v ? v.toUpperCase() : v) || "PAN is not valid!!",
			validatePhone: v => _validPhoneNoRule(v),
			STATUS,
			editLocationOpen: false
		};
	},
	components: {
		"upload-media": UploadMedia,
		"edit-location": EditLocation
	},
	computed: {
		...mapState({
			userData: state => state.user.userData,
			retailerData: state => state.retail.retailerData,
			jeet11PartnerDetails: state => state.jeet11.jeet11PartnerDetails
		}),
		...mapGetters({
			dstrSignatureStatus: "jeet11/dstrSignatureStatus",
			isJeet11Distributor: "auth/isJeet11Distributor",
			dstrSignatureRemark: "jeet11/dstrSignatureRemark"
		}),
		isJeet11TSM() {
			return this.userType === "tsm";
		},
		isJeet11RBM() {
			return this.userType === "rbm";
		},
		isJeet11Retailer() {
			return this.userType === "dstrRetail";
		},
		isRetailerDetailsValid() {
			const {
				shopName,
				address,
				tsmNumber, //editable
				rbmNumber //editable
			} = this.retailerDetails;
			return (
				!!this.retailerName &&
				!!shopName &&
				!!address &&
				((!this.isJeet11TSM && !this.isJeet11RBM && !!tsmNumber) ||
					(this.isJeet11TSM && !!rbmNumber))
			);
		},
		isBankDetailsValid() {
			const {
				accountNumber,
				accountIfsc,
				accountName
			} = this.bankDetails;
			return !!accountNumber && !!accountIfsc && !!accountName;
		},
		isDocumentDetailsValid() {
			const {
				gstNumber,
				gstCertificate,
				PAN,
				PANimage
			} = this.documentDetails;
			return !!gstNumber && !!gstCertificate && !!PAN && !!PANimage;
		},
		saveDisabled() {
			return !(
				this.isRetailerDetailsValid &&
				this.isBankDetailsValid &&
				this.isDocumentDetailsValid
			);
		},
		disableStateSelect() {
			return (
				this.stateAlreadySelected &&
				this.states.length > 0 &&
				this.selectedState.length > 0
			);
		},
		disableCitySelect() {
			return (
				this.cityAlreadySelected &&
				this.cities.length > 0 &&
				!!this.selectedCity
			);
		}
	},
	created() {
		this.fetchStates();
	},
	mounted() {
		this.resetForm();
	},
	beforeDestroy() {},
	methods: {
		fetchJeet11WalletDetails() {
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					isSchemeRequired: true
				})
				.catch(() => {})
				.then(data => {
					const { response } = data;
					const { userType, shopType, retailerName } = response;
					this.userType = userType;
					this.shopType = shopType;
					this.retailerName = retailerName;
				});
		},
		resetForm() {
			this.isEditMode = false;
			this.getRetailerInfo();
			this.fetchJeet11WalletDetails();
			this.fetchSignature();
		},
		savePANImage(url) {
			if (url) {
				this.documentDetails.PANimage = url.fileUrl;
			}
		},
		saveGSTCertificate(url) {
			if (url) {
				this.documentDetails.gstCertificate = url.fileUrl;
			}
		},
		saveSignature(url) {
			if (url) {
				this.documentDetails.signature = url.fileUrl;
			}
		},
		fetchSignature() {
			if (this.isJeet11Distributor) {
				this.$store
					.dispatch(GET_DSTR_SIGNATURE.dispatch)
					.catch(error => {
						console.log("error: ", error);
						this.$store.dispatch(SHOW_ALERT.dispatch, {
							text: "Error in Fetching Signature!"
						});
					})
					.then(data => {
						const { signatureUrl = "" } =
							data.filter(val => val.verified)[0] || {};
						this.documentDetails.signature = signatureUrl;
					});
			}
		},
		fetchStates() {
			if (!this.fetchStatesLoading) {
				this.fetchStatesLoading = true;
				this.$store
					.dispatch(FETCH_REGIONS.dispatch, {
						regionType: REGION_TYPE.STATE,
						dataKey: "states"
					})
					.catch(() => {})
					.then(data => {
						const { response } = data;
						if (Array.isArray(response)) {
							this.states = response;
						}
						this.fetchStatesLoading = false;
					});
			}
		},
		fetchCities() {
			this.selectedCity = null;
			this.fetchCitiesLoading = true;
			this.$store
				.dispatch(FETCH_REGIONS.dispatch, {
					regionType: REGION_TYPE.CITY,
					state: this.selectedState,
					dataKey: "cities"
				})
				.catch(() => {})
				.then(data => {
					this.fetchCitiesLoading = false;
					const { response } = data;
					if (Array.isArray(response)) {
						this.cities = response.map(city => city.toUpperCase());
					}
				});
		},
		getRetailerInfo() {
			const { userId } = this.retailerData;
			if (userId) {
				this.$store
					.dispatch(GET_RETAILER_PROFILE.dispatch, { userId })
					.catch(error => {
						console.log("error: ", error);
						this.$store.dispatch(SHOW_ALERT.dispatch, {
							text: "Error in Fetching User Profile!"
						});
					})
					.then(data => {
						const {
							shopName = "",
							state = null,
							address = "",
							city = null,
							tsmNumber = "",
							rbmNumber = "",
							PAN = "",
							PANimage = "",
							gstNumber = "",
							gstCertificate = "",
							bankDetails = {}
						} = data;
						// to remove 91 prefix
						const formattedTsmNumber =
							tsmNumber && tsmNumber.toString().length === 12
								? tsmNumber.toString().slice(2)
								: tsmNumber;
						const formattedRbmNumber =
							rbmNumber && rbmNumber.toString().length === 12
								? rbmNumber.toString().slice(2)
								: rbmNumber;

						const {
							accountNumber = "",
							accountIfsc = "",
							accountName = ""
						} = bankDetails;
						this.retailerDetails = {
							shopName,
							address,
							tsmNumber: formattedTsmNumber,
							rbmNumber: formattedRbmNumber
						};
						this.selectedState = state ? state.toUpperCase() : null;
						this.defaultCity = city ? city.toUpperCase() : null;

						this.documentDetails = {
							...this.documentDetails,
							PAN,
							PANimage,
							gstNumber,
							gstCertificate
						};
						this.bankDetails = {
							accountNumber,
							accountIfsc,
							accountName
						};
						this.isPANDetailsExist = !!PAN && !!PANimage;
						this.stateAlreadySelected = !!this.selectedState;
						this.addressAlreadyExists = !!address;
						this.gstNumberExists = !!gstNumber;
						this.shopNameExists = !!shopName;
						this.gstCertificateExists = !!gstCertificate;
						this.isUserCreated =
							!!gstCertificate &&
							!!gstNumber &&
							!!PAN &&
							!!PANimage;
					});
			}
		},
		updateRetailerProfile() {
			const {
				shopName,
				address,
				tsmNumber,
				rbmNumber
			} = this.retailerDetails;
			const {
				accountNumber,
				accountIfsc,
				accountName
			} = this.bankDetails;
			const {
				gstNumber,
				gstCertificate,
				PAN,
				PANimage,
				signature
			} = this.documentDetails;
			const hasBankDetails =
				!!accountNumber || !!accountIfsc || !!accountName;
			const hasDocumentDetails =
				!!gstNumber || !!gstCertificate || !!PAN || !!PANimage;

			if (
				this.isJeet11Distributor &&
				this.dstrSignatureStatus === STATUS.REJECTED &&
				!signature
			) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Please Upload Signature!!"
				});
				return;
			}

			if (tsmNumber && !checkPhoneNumberValidity(tsmNumber)) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Enter only 10 digit TSM Number!!"
				});
				return;
			}

			if (rbmNumber && !checkPhoneNumberValidity(rbmNumber)) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Enter only 10 digit RBM Number!!"
				});
				return;
			}

			if (!(this.selectedState && this.selectedCity)) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "State or city not selected!!"
				});
				return;
			}

			if (hasBankDetails) {
				if (!accountNumber) {
					this.$store.dispatch(SHOW_ALERT.dispatch, {
						text: "Account Number not entered!!"
					});
					return;
				}
				if (!accountIfsc) {
					this.$store.dispatch(SHOW_ALERT.dispatch, {
						text: "Account IFSC not entered!!"
					});
					return;
				}
				if (!validIFSC(accountIfsc)) {
					this.$store.dispatch(SHOW_ALERT.dispatch, {
						text: "IFSC is not valid"
					});
					return;
				}
				if (!accountName) {
					this.$store.dispatch(SHOW_ALERT.dispatch, {
						text: "Account Name not entered!!"
					});
					return;
				}
			}

			if (
				(PAN || PANimage) &&
				((PAN && !PANimage) || (!PAN && PANimage))
			) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "PAN number and Pan Image are mandatory."
				});
				return;
			}
			if (PAN && !checkValidPAN(PAN.toUpperCase())) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "PAN Number is not valid."
				});
				return;
			}
			const payload = {
				isCreateCall: !this.isUserCreated,
				retailerDetails: {
					...(this.selectedState
						? { state: this.selectedState }
						: {}),
					...(this.selectedCity ? { city: this.selectedCity } : {}),
					...(this.retailerName
						? { retailerName: this.retailerName }
						: {}),
					...(shopName ? { shopName } : {}),
					...(address ? { address } : {}),
					...(!this.isJeet11TSM && !this.isJeet11RBM && tsmNumber
						? { tsmNumber: Number("91" + tsmNumber) }
						: {}),
					...(this.isJeet11TSM && rbmNumber
						? { rbmNumber: Number("91" + rbmNumber) }
						: {})
				},
				...(hasBankDetails
					? {
							bankDetails: {
								...(accountNumber ? { accountNumber } : {}),
								...(accountIfsc
									? {
											accountIfsc: accountIfsc.toUpperCase()
									  }
									: {}),
								...(accountName ? { accountName } : {})
							}
					  }
					: {}),
				...(!this.isUserCreated && hasDocumentDetails
					? {
							documentDetails: {
								...(gstNumber && this.isJeet11Distributor
									? { gstNumber }
									: {}),
								...(gstCertificate && this.isJeet11Distributor
									? { gstCertificate }
									: {}),
								...(PAN ? { PAN: PAN.toUpperCase() } : {}),
								...(PANimage ? { PANimage } : {})
							}
					  }
					: {})
			};
			if (!this.isUpdateProfileLoading) {
				this.isUpdateProfileLoading = true;
				if (
					this.dstrSignatureStatus === STATUS.REJECTED &&
					this.isJeet11Distributor
				)
					this.$store
						.dispatch(UPLOAD_DSTR_SIGNATURE.dispatch, {
							signatureUrl: this.documentDetails.signature
						})
						.catch(() => {})
						.then(() => {
							this.fetchSignature();
							this.fetchJeet11WalletDetails();
						});
				this.$store
					.dispatch(UPDATE_RETAILER_PROFILE.dispatch, payload)
					.catch(() => {})
					.then(() => {
						this.isUpdateProfileLoading = false;
						this.isEditMode = false;
						this.getRetailerInfo();
						this.$store.dispatch(SHOW_ALERT.dispatch, {
							text: "Profile Updated Successfully!!"
						});
					});
			}
		}
	},
	filters: {},
	watch: {
		selectedState(newVal) {
			if (newVal) {
				this.fetchCities();
			}
		},
		cities(newVal) {
			if (newVal.length > 0) {
				this.selectedCity = this.defaultCity;
				this.cityAlreadySelected = !!this.defaultCity;
			}
		}
	}
};
</script>

<style lang="scss">
.profile-avatar {
	position: relative;
	width: 175px;
	height: 175px;
	margin-top: 0px;
	border-radius: 50%;
	// border: 6px solid #fff;
	background-color: #dedede;
}
.top-shifted {
	position: relative;
	z-index: 1;
	margin-top: -90px;
}
.right-divider {
	border-right: 1px solid #dedede;
}
.all-center {
	position: absolute;
	left: 50%;
	bottom: 50%;
	transform: translateX(-50%) translateY(25%);
}
.max-width-175 {
	max-width: 175px;
}
.referralCode {
	border: 5px dashed grey;
	border-radius: 14px;
	background: #eee;
	color: rgb(68, 67, 67);
}
.border-outline {
	border: 1px dashed #23395c;
	border-radius: 12px;
	margin-bottom: 16px;
}
.section-heading {
	position: absolute;
	background: white;
	top: -10px;
	left: 6px;
	padding: 0 4px;
}
.submit-btn {
	position: fixed;
	bottom: 0;
	background: white;
	width: 100%;
	max-width: 600px;
}
.uppercase input {
	text-transform: uppercase;
}
.notif-dot {
	background-color: #e61818c4;
	width: 9px;
	height: 9px;
	border-radius: 100%;
	position: absolute;
	right: -2px;
	top: -2px;
	animation: blinker 0.8s cubic-bezier(0.895, 0.03, 0.685, 0.22) infinite
		alternate;
}
@keyframes blinker {
	from {
		opacity: 1;
	}
	to {
		opacity: 0.2;
	}
}
</style>
